<template lang="pug">
  main
    NavBarDirectorio
    Loader(v-show="isLoading")
    section.section(v-show="!isLoading")
      .container
        .columns
          .column.is-half.is-offset-one-quarter.has-text-centered
            h1.title Directorio Telefónico&nbsp
              a.button.is-black.is-rounded(@click='backPage')
                i.fas.fa-times
        .columns.is-mobile
          .column.is-12.has-text-centered
              input#allH.is-checkradio.is-danger(type='radio', value='' v-model='query' checked='checked')
              label.is-size-6(for='allH') Todos
              input#irgeH.is-checkradio.is-danger(type='radio', value='IRGE' v-model='query')
              label.is-size-6(for='irgeH') IRGE
              input#tpaH.is-checkradio.is-danger(type='radio', value='TPA' v-model='query')
              label.is-size-6(for='tpaH') TPA
              input#ductoH.is-checkradio.is-danger(type='radio', value='LPG Ducto' v-model='query')
              label.is-size-6(for='ductoH') Ducto
              input#corpoH.is-checkradio.is-danger(type='radio', value='CORP' v-model='query')
              label.is-size-6(for='corpoH') Corporativo
              input#giaH.is-checkradio.is-danger(type='radio', value='GIA' v-model='query')
              label.is-size-6(for='giaH') GIA
              input#estacionesH.is-checkradio.is-danger(type='radio', value='EST' v-model='query')
              label.is-size-6(for='estacionesH') Estaciones

        .columns.is-table-directiorio
          .column.is-half.is-offset-one-quarter.has-text-centered
            .table-responsive
              table.table.table-hover.table-sm.is-responsive.is-fullwidth
                thead
                  tr
                    th Ext/Línea
                    th.th-description Usuario
                    th.th-description Ubicación
                tbody
                  tr(v-for="d in directorioSel")
                    td {{ d.ext }}
                    td.td-name
                      b {{ d.usuario }}
                    td
                      | {{ d.ubicacion }}
</template>


<script>
import Loader from '@/components/shared/Loader.vue'
import NavBarDirectorio from '@/components/directorio_Componentes/NavBarDirectorio.vue'
import { mapState } from 'vuex'

export default {
  name: 'HomeDirectorio',
  components: { Loader, NavBarDirectorio },
  data () {
    return {
      isLoading: true,
      query: '',
      directorioSel: [],
      directorio: [
          { 'ext': '102', 'usuario': 'Gerente administrativo IRGE', 'ubicacion': 'IRGE', 'code': '69349'},
          { 'ext': '103', 'usuario': 'Gerencia IRGE', 'ubicacion': 'IRGE', 'code': '58513'},
          { 'ext': '5919165373', 'usuario': 'C.P. Héctor Torres', 'ubicacion': 'IRGE'},
          { 'ext': '104', 'usuario': 'Asistente Gerencia IRGE', 'ubicacion': 'IRGE', 'code': '35857'},
          { 'ext': '106', 'usuario': 'Jefatura Mantto. IRGE', 'ubicacion': 'IRGE', 'code': '44045'},
          { 'ext': '107', 'usuario': 'Jefatura Operación IRGE', 'ubicacion': 'IRGE', 'code': '89235'},
          { 'ext': '108', 'usuario': 'Cuarto de Control IRGE', 'ubicacion': 'IRGE', 'code': '86602'},
          { 'ext': '113', 'usuario': 'Almacén IRGE', 'ubicacion': 'IRGE', 'code': '35541'},
          { 'ext': '115', 'usuario': 'Oficina Propangol IRGE', 'ubicacion': 'IRGE', 'code': '65746'},
          { 'ext': '116', 'usuario': 'Contador JR IRGE', 'ubicacion': 'IRGE', 'code': '65746'},
          { 'ext': '117', 'usuario': 'Jefatura Seguridad IRGE', 'ubicacion': 'IRGE', 'code': '51092'},
          { 'ext': '118', 'usuario': 'Representante PEMEX IRGE', 'ubicacion': 'IRGE', 'code': '42993'},
          { 'ext': '120', 'usuario': 'Báscula IRGE', 'ubicacion': 'IRGE', 'code': '39333'},
          { 'ext': '124', 'usuario': 'Asis Admin IRGE', 'ubicacion': 'IRGE', 'code': '19691'},
          { 'ext': '131', 'usuario': 'Documentación IRGE', 'ubicacion': 'IRGE', 'code': 'PEND.'},
          { 'ext': '132', 'usuario': 'Movenergy IRGE', 'ubicacion': 'IRGE', 'code': 'PEND.'},
          { 'ext': '125', 'usuario': '23 Puntos', 'ubicacion': 'IRGE', 'code': 'PEND.'},
          { 'ext': '400', 'usuario': 'EB04', 'ubicacion': 'EST', 'code': '55555'},
          { 'ext': '401', 'usuario': 'Gerencia LPG Ducto', 'ubicacion': 'EST', 'code': '31894'},
          { 'ext': '402', 'usuario': 'Cordinación LPG Ducto', 'ubicacion': 'EST', 'code': '96721'},
          { 'ext': '403', 'usuario': 'GIA', 'ubicacion': 'GIA', 'code': '70753'},
          { 'ext': '404', 'usuario': 'Asistente LPG Ducto', 'ubicacion': 'EST', 'code': '78508'},
          { 'ext': '405', 'usuario': 'Asistente GIA', 'ubicacion': 'GIA', 'code': '78673'},
          { 'ext': '407', 'usuario': 'Auxiliar SIMA', 'ubicacion': 'EST', 'code': '49933'},
          { 'ext': '408', 'usuario': 'Instrumentación/Automatización', 'ubicacion': 'GIA', 'code': '55555'},
          { 'ext': '409', 'usuario': 'Sistemas/Telecomunicaciones', 'ubicacion': 'GIA', 'code': '55555'},
          { 'ext': '410', 'usuario': 'Almacén GIA', 'ubicacion': 'GIA', 'code': '55555'},
          { 'ext': '326', 'usuario': 'VS-26', 'ubicacion': 'LPG Ducto', 'code': '55555'},
          { 'ext': '325', 'usuario': 'VS-25', 'ubicacion': 'LPG Ducto', 'code': '55555'},
          { 'ext': '324', 'usuario': 'VS-24', 'ubicacion': 'LPG Ducto', 'code': '55555'},
          { 'ext': '323', 'usuario': 'VS-23', 'ubicacion': 'LPG Ducto', 'code': '55555'},
          { 'ext': '322', 'usuario': 'VS-22', 'ubicacion': 'LPG Ducto', 'code': '55555'},
          { 'ext': '321', 'usuario': 'VS-21', 'ubicacion': 'LPG Ducto', 'code': '55555'},
          { 'ext': '320', 'usuario': 'VS-20', 'ubicacion': 'LPG Ducto', 'code': '55555'},
          { 'ext': '319', 'usuario': 'VS-19', 'ubicacion': 'LPG Ducto', 'code': '55555'},
          { 'ext': '318', 'usuario': 'VS-18', 'ubicacion': 'LPG Ducto', 'code': '55555'},
          { 'ext': '317', 'usuario': 'VS-17', 'ubicacion': 'LPG Ducto', 'code': '55555'},
          { 'ext': '316', 'usuario': 'VS-16', 'ubicacion': 'LPG Ducto', 'code': '55555'},
          { 'ext': '800', 'usuario': 'ERM-TLAUTLA', 'ubicacion': 'EST', 'code': '55555'},
          { 'ext': '300', 'usuario': 'EB03', 'ubicacion': 'EST', 'code': '55555'},
          { 'ext': '215', 'usuario': 'VS-15', 'ubicacion': 'LPG Ducto', 'code': '55555'},
          { 'ext': '214', 'usuario': 'VS-14', 'ubicacion': 'LPG Ducto', 'code': '55555'},
          { 'ext': '213', 'usuario': 'VS-13', 'ubicacion': 'LPG Ducto', 'code': '55555'},
          { 'ext': '212', 'usuario': 'VS-12', 'ubicacion': 'LPG Ducto', 'code': '55555'},
          { 'ext': '211', 'usuario': 'VS-11', 'ubicacion': 'LPG Ducto', 'code': '55555'},
          { 'ext': '210', 'usuario': 'VS-10', 'ubicacion': 'LPG Ducto', 'code': '55555'},
          { 'ext': '209', 'usuario': 'VS-09', 'ubicacion': 'LPG Ducto', 'code': '55555'},
          { 'ext': '208', 'usuario': 'VS-08', 'ubicacion': 'LPG Ducto', 'code': '55555'},
          { 'ext': '200', 'usuario': 'EB02', 'ubicacion': 'EST', 'code': '55555'},
          { 'ext': '607', 'usuario': 'VS-07', 'ubicacion': 'LPG Ducto', 'code': '55555'},
          { 'ext': '606', 'usuario': 'VS-06', 'ubicacion': 'LPG Ducto', 'code': '55555'},
          { 'ext': '605', 'usuario': 'VS-05', 'ubicacion': 'LPG Ducto', 'code': '55555'},
          { 'ext': '604', 'usuario': 'VS-04', 'ubicacion': 'LPG Ducto', 'code': '55555'},
          { 'ext': '603', 'usuario': 'VS-03', 'ubicacion': 'LPG Ducto', 'code': '55555'},
          { 'ext': '602', 'usuario': 'VS-02', 'ubicacion': 'LPG Ducto', 'code': '55555'},
          { 'ext': '601', 'usuario': 'VS-01', 'ubicacion': 'LPG Ducto', 'code': '55555'},
          { 'ext': '650', 'usuario': 'Interconexión', 'ubicacion': 'LPG Ducto', 'code': '55555'},
          { 'ext': '600', 'usuario': 'EB01', 'ubicacion': 'EST', 'code': '55555'},
          { 'ext': '500', 'usuario': 'EB00', 'ubicacion': 'EST', 'code': '55555'},
          { 'ext': '501', 'usuario': 'Gerencia TPA', 'ubicacion': 'TPA', 'code': '12577'},
          { 'ext': '502', 'usuario': 'Asistente TPA', 'ubicacion': 'TPA', 'code': '21311'},
          { 'ext': '504', 'usuario': 'Asistente Admon.', 'ubicacion': 'TPA', 'code': '87481'},
          { 'ext': '520', 'usuario': 'Sistemas TPA', 'ubicacion': 'TPA', 'code': '55555'},
          { 'ext': '5521679500', 'usuario': 'Línea 1', 'ubicacion': 'CORP', 'code': ''},
          { 'ext': '5521673091', 'usuario': 'Línea 2', 'ubicacion': 'CORP', 'code': ''},
          { 'ext': '5521679503', 'usuario': 'Línea 3', 'ubicacion': 'CORP', 'code': ''},
          { 'ext': '5521679504', 'usuario': 'Línea 4', 'ubicacion': 'CORP', 'code': ''},
          { 'ext': '801', 'usuario': 'Sandra Cabrera', 'ubicacion': 'CORP', 'code': ''},
          { 'ext': '802', 'usuario': 'Ahtsiri Liprandi', 'ubicacion': 'CORP', 'code': ''},
          { 'ext': '803', 'usuario': 'César López', 'ubicacion': 'CORP', 'code': ''},
          { 'ext': '804', 'usuario': 'Aline Peña', 'ubicacion': 'CORP', 'code': ''},
          { 'ext': '805', 'usuario': 'Orlando Ruiz', 'ubicacion': 'CORP', 'code': ''},
          { 'ext': '806', 'usuario': 'Norma González', 'ubicacion': 'CORP', 'code': ''},
          { 'ext': '807', 'usuario': 'Pedro Piza', 'ubicacion': 'CORP', 'code': ''},
          { 'ext': '808', 'usuario': 'Fernanda Fragoso', 'ubicacion': 'CORP', 'code': ''},
          { 'ext': '809', 'usuario': 'Omar Tagua', 'ubicacion': 'CORP', 'code': ''},
          { 'ext': '810', 'usuario': 'Monserrat Miranda', 'ubicacion': 'CORP', 'code': ''},
          { 'ext': '811', 'usuario': 'Alejandra de Luna', 'ubicacion': 'CORP', 'code': ''},
          { 'ext': '812', 'usuario': 'Rapahel Olavarria, Brenda Portugués', 'ubicacion': 'CORP', 'code': ''},
          { 'ext': '813', 'usuario': 'Luisa Adriana', 'ubicacion': 'CORP', 'code': ''},
          { 'ext': '814', 'usuario': 'Adriana Carapia, Miguel Vences, Joana Barrios', 'ubicacion': 'CORP', 'code': ''},
          { 'ext': '816', 'usuario': 'Recepción', 'ubicacion': 'CORP', 'code': ''},
        ]
    }
  },
  watch: {
    query () {
      this.buscar()
    }
  },
  methods: {
    iniciarComponente() {
      setTimeout(() => {
        this.buscar()
        this.isLoading = false
      }, 1000)
    },
    buscar () { 
      if (this.query === '') {
        this.directorioSel = this.directorio
      } else {
        this.directorioSel = {}
        this.directorioSel = this.directorio.filter( direc => direc.ubicacion === this.query )
      }
    },
    backPage () {
      this.$router.back()
    },
  },
  created () {
    this.iniciarComponente()
  },
  computed: {
    ...mapState(['logueado', 'userLogin'])
  }
}
</script>

<style lang="css" scoped>

  .is-table-directiorio{
    margin-bottom: 80px;
  }

  @media screen and (max-width: 800px) {
    .is-responsive {
      width: 100%;
      border-collapse: collapse;
      border-spacing: 0;
      display: block;
      position: relative;
    }
    .is-responsive td:empty:before {
      content: " ";
    }
    .is-responsive th,
    .is-responsive td {
      margin: 0;
      vertical-align: top;
    }
    .is-responsive th {
      text-align: left;
    }
    .is-responsive thead {
      border-right: solid 2px #dbdbdb;
      display: block;
      float: left;
    }
    .is-responsive thead tr {
      display: block;
      padding: 0 10px 0 0;
    }
    .is-responsive thead tr th::before {
      content: " ";
    }
    .is-responsive thead td,
    .is-responsive thead th {
      border-width: 0 0 1px;
    }
    .is-responsive tbody {
      display: block;
      width: auto;
      position: relative;
      overflow-x: auto;
      white-space: nowrap;
    }
    .is-responsive tbody tr {
      display: inline-block;
      vertical-align: top;
    }
    .is-responsive th {
      display: block;
      text-align: right;
    }
    .is-responsive td {
      display: block;
      min-height: 1.25em;
      text-align: left;
    }
    .is-responsive th:last-child,
    .is-responsive td:last-child {
      border-bottom-width: 0;
    }
    .is-responsive tr:last-child td:not(:last-child) {
      border: 1px solid #dbdbdb;
      border-width: 0 0 1px;
    }
    .is-responsive.is-bordered td,
    .is-responsive.is-bordered th {
      border-width: 1px;
    }
    .is-responsive.is-bordered tr td:last-child,
    .is-responsive.is-bordered tr th:last-child {
      border-bottom-width: 1px;
    }
    .is-responsive.is-bordered tr:last-child td,
    .is-responsive.is-bordered tr:last-child th {
      border-width: 1px;
    }
  }

  @media (min-width: 320px) and (max-width: 480px) {
    .is-checkradio[type="radio"] + label {
      font-size: 0.75rem;
    }
  }

</style>


// WEBPACK FOOTER //
// src/components/directorio_Componentes/HomeDirectorio.vue